<template>
    <div class="q-pa-md">

        <q-form class="q-gutter-md row items-start" @submit="onSubmit">
            <div class="q-pa-md example-row-stacked-to-horizontal" style="width: 100%">
                <div class="row">
                    <q-input class="col-12 col-md-5 q-px-md q-pb-md" dense filled v-model="keyword" label="Contains Word"
                        lazy-rules />
                    <q-select class="col-12 col-md-2 q-px-md q-pb-md" dense filled v-model="action"
                        :options="action_options" label="Action" @update:model-value="onChange()" />
                    <q-input class="col-12 col-md-5 q-px-md q-pb-md" dense filled v-model="serial.command"
                        v-if="serial.show" label="Serial Command" lazy-rules />
                </div>
                <q-btn label="Add" type="submit" color="primary" />
            </div>

            <div style="width: 100%">
                <q-table class="alarm-table" flat bordered title="Alarms" :rows="rows" :columns="columns" row-key="index"
                    virtual-scroll>
                    <template v-slot:body-cell-actions="props">
                        <q-td :props="props">
                            <q-btn icon="delete" @click="onDeleteAlarm(props.row)"></q-btn>
                        </q-td>
                    </template>
                    <template v-slot:body-cell-type="props">
                        <q-td :props="props">
                            <q-badge v-if="props.value === 'Serial'" class='bg-grey' :label="props.value"></q-badge>
                            <q-badge v-else-if="props.value === 'Browser notification'" class='bg-blue'
                                :label="props.value"></q-badge>
                        </q-td>
                    </template>
                </q-table>
            </div>
        </q-form>

    </div>
</template>
  
<style>
.alarm-table {
    height: 400px;
}
</style>
  
<script>
// import { ref } from 'vue'

export default {
    name: 'AlarmConfiguration',
    data() {
        return {
            keyword: null,
            action_options: ['Serial', 'Browser notification'],
            action: null,
            serial: {
                show: false,
                command: null,
            },
            alarms: this.$store.state.alarms,
            columns: [
                { name: 'keyword', label: 'Alarm', field: 'keyword', align: 'left', },
                { name: 'type', label: 'Type', field: 'type', align: 'left', },
                { name: 'command', label: 'Command', field: 'command', align: 'left', },
                { name: 'actions', label: 'Action' }
            ],
            rows: [
            ],
        }
    },
    mounted() {
        if (this.alarms.length > 0) {
            this.rows = this.alarms;
        }
    },
    methods: {
        onChange() {
            if (this.action == 'Serial') {
                this.serial.show = true;
            } else {
                this.serial.show = false;
            }
        },
        onSubmit() {
            var alarm = {};
            if (this.action == 'Serial') {
                alarm.type = 'Serial';
                alarm.keyword = this.keyword;
                alarm.command = this.serial.command;
                this.$store.commit('pushAlarm', alarm);
            } else if (this.action == 'Browser notification') {
                alarm.type = 'Browser notification';
                alarm.keyword = this.keyword;
                alarm.command = null;
                this.$store.commit('pushAlarm', alarm);
            }

            this.rows = this.alarms;
        },
        onDeleteAlarm(row) {
            const index = this.alarms.indexOf(row);
            confirm("Are you sure you want to delete this item?") &&
                this.$store.commit('deleteAlarm', index);
            this.rows = this.alarms;
        },
    }
}


</script>
  